//
import React, { useEffect } from 'react';
import customAuthenticator from './components/CustomAuth';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports'; // if you are using Amplify CLI
import Routes from './views/Routes'
import { useDispatch, useSelector } from "react-redux"
import { setSysAdmin } from './store/userSlice'
import { setTenants } from './store/tenantSlice'
import { setTenant } from './store/siteSlice'
import {getTaskmanUrl} from './apihelpers/apihelpers'

Amplify.configure(awsconfig);

// Configure the base URL for the fataskman service.
// This value comes from Amazon API Gateway, which links this URL to 
// the actual service running in a Docker container.
var taskmanUrl = getTaskmanUrl();
console.log("taskmanUrl: " + taskmanUrl);

Amplify.configure({
  API: {
    // This part sets up using the IdToken instead of AccessToken for authorization.
    // This is so the backend can verify the tenant id value in the IdToken.
    graphql_headers: async () => {
      const session = await Amplify.Auth.currentSession();
      return ({
        'Authorization': session.getIdToken().getJwtToken()
      })},
    endpoints: [
        {
            name: "fataskman",
            endpoint: taskmanUrl,
            custom_header: 
              async () => {
                const session = await Amplify.Auth.currentSession();
                return ({
                  Authorization : session.getIdToken().getJwtToken()
                })
              }
        }
    ]
  }
});

function App(/*props*/) {
    const dispatch = useDispatch();
    const isSysAdmin = useSelector(state=>state.user.sysAdmin)
    useEffect(() => {
        async function init(){
            //this is called when a user logs in
            //it wont be called again if something changes on the page
            let isSysAdmin = false;
            const session = await Amplify.Auth.currentSession();
            const groups = session.getIdToken().payload["cognito:groups"]
            if (groups && groups[0] === "sysadmin"){
                isSysAdmin = true;
            }
            // Clear out any old data that might be in the store from
            // a previous user.
            dispatch(setSysAdmin(isSysAdmin));
            dispatch(setTenants([]));
            dispatch(setTenant(""));
        }
        init();
    }, [dispatch]);


    return (
        <div className="App" style= {{'overflow':'hidden'}}>
          <Routes user={{sysadmin:isSysAdmin}}/>
        </div>
    );
}

export default customAuthenticator(App);
